import { mapAtom } from '../../atoms/map/map'
import { findLayer } from '../utils/findLayer'

import { changelogRemoveGeofenceFeatures } from './utils/changelogRemoveGeofenceFeatures'
import { changelogAddGeofenceFeatures } from './utils/changelogAddGeofenceFeatures'
import { changelogUpdateGeofenceFeatures } from './utils/changelogUpdateGeofenceFeatures'

export const createUpdateGeofenceFeaturesFromChangelog = (
  markers: uui.domain.ui.map.markers.MapMarkers['geofence'],
  mapStyles: uui.domain.ui.map.markers.MapStyles['geofence'],
  selection: Set<string>,
  changelog: uui.domain.api.Changelog,
) => {
  // ATTENTION: Currently all changelog are applied as soon as they arrive, also when the map is not visible
  // `ignoreSelection` it will be used to avoid to apply any selection information to the map when applying cached updater functions.
  // after all cached updates will be applied a refresh selection action will be required
  return async (_ignoreSelection: boolean = false) => {
    const map = mapAtom.map
    const layer = findLayer(map, 'geofence')

    // remove
    await changelogRemoveGeofenceFeatures(layer, selection, changelog.remove.values())

    // add
    await changelogAddGeofenceFeatures(layer, markers, mapStyles, selection, changelog.add.values())

    // update
    await changelogUpdateGeofenceFeatures(
      layer,
      markers,
      mapStyles,
      selection,
      changelog.update.values(),
    )
  }
}
